import { render, staticRenderFns } from "./AppMessages.vue?vue&type=template&id=3085bf99&scoped=true&"
import script from "./AppMessages.vue?vue&type=script&lang=js&"
export * from "./AppMessages.vue?vue&type=script&lang=js&"
import style0 from "./AppMessages.vue?vue&type=style&index=0&id=3085bf99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3085bf99",
  null
  
)

export default component.exports